import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { datadogRum } from '@datadog/browser-rum';
import { OAuthRedirect } from '../../OAuth/OAuthRedirect';
import { getBackendUrl } from '../../../../services/get-backend-url';

type LatticeState = {
  sessionKey: string;
};

const BACKEND_ROUTE = getBackendUrl();

const LatticeOauthCallback = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const oAuthState = {
    state: queryParams.get('state'),
    code: queryParams.get('code'),
    error: queryParams.get('error'),
  };

  const sessionKey =
    oAuthState.state &&
    (JSON.parse(oAuthState.state || '') as LatticeState)?.sessionKey;

  if (sessionKey) {
    datadogRum.setUser({ id: sessionKey });

    datadogRum.addAction('lattice_oauth_callback', { oAuthState });
  }

  const { isLoading, error: postError } = useQuery({
    queryKey: ['lattice_oauth_state_update', sessionKey],
    queryFn: async () => {
      const response = await axios.post(
        `${BACKEND_ROUTE}/auth/oauth/state/${sessionKey}`,
        { oAuthState },
      );

      window.close();

      return response;
    },
    refetchOnWindowFocus: false,
    enabled: !!sessionKey,
  });

  return <OAuthRedirect isLoading={isLoading} error={postError} />;
};

export default LatticeOauthCallback;
